<template>
  <v-card class="elevation-12 mt-3 mx-1" :loading="loading">
    <v-toolbar color="primary" dark flat>
      {{ pageTitle }}
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" lg="3">
          <v-text-field v-model="mailUid"
                        label="Идентификатор письма"
                        @keyup.enter="onMailUidKepUpEnter"
                        ref="mailUid"
          />
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th>№</th>
            <th>Идентификатор</th>
            <th>Получатель</th>
            <th>Область</th>
            <th>Район</th>
            <th>Адрес</th>
            <th>Дата поступления</th>
            <th>Печатный пакет</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="mail in displayMails" :key="mail.id"
              :class="{'black': mail.isPerformedNotTry, 'white--text': mail.isPerformed}">
            <td>{{ mail.displayNumber }}</td>
            <td>
              {{ mail.uid }}
            </td>
            <td>{{ mail.receiver }}</td>
            <td>{{ mail.region.name }}</td>
            <td>{{ mail.area.name }}</td>
            <td>{{ mail.address }}</td>
            <td class="text-center">
              {{ mail.createdOn.format('DD.MM.YYYY') }}
              <br>
              {{ mail.createdOn.format('HH:mm:ss') }}
            </td>
            <td>
              {{ mail.printPackage.uid }}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import MailService from "@/services/mail.service";
import Mappers from '@/mappers'
import _ from "underscore";
import {AllowDeleteFromPostPackage} from "@/enums/permission";

export default {
  name: "MailBulkUnsetPostPackageView",
  data() {
    return {
      mails: [],
      loading: false,
      mailUid: '',

      pageTitle: 'Массовый досыл писем'
    }
  },
  validations: {
    mailUid: {
      required
    }
  },
  computed: {
    displayMails() {
      let number = 1;
      return _.map(this.mails, m => {
        m.displayNumber = number++

        return m
      }).reverse()
    },
    isAllowBulkUnsetPostPackageMails() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeleteFromPostPackage
      })
    },
  },
  methods: {
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },
    onMailUidKepUpEnter() {
      this.$v.$touch()
      this.mailUid = this.mailUid.trim()

      if (!this.$v.$invalid) {
        this.loading = true
        this.$store.dispatch(LAYOUT_LOADING_START)

        MailService.unsetPostPackage(this.mailUid, null, null)
            .then(response => {
              let mail = Mappers.mapMail(response.data)
              this.mails.push(mail)
            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)

              this.mailUid = ''
            })
      } else {
        this.mailUid = ''
      }
    }
  },
  created() {
    if (this.isAllowBulkUnsetPostPackageMails) {
      this.setPageTitle()
    } else {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
